module.exports = __webpack_public_path__ + "static/media/wooyoungmi.a64a7f80.jpg";